import axios from "axios";
import { keycloak } from "../../../../lib/keycloak";
import { ContactCreateDTO, ContactDTO, ContactUpdateDTO } from "./dto";
import { ContactService } from "./service";

export class ContactServiceImpl implements ContactService {
    public createContact(data: ContactCreateDTO): Promise<number> {
        return axios.post("/api/contact",
            data,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }

    public updateContact(id: string, data: ContactUpdateDTO): Promise<void> {
        return axios.put("/api/contact/" + id,
            data,
            {
                headers: {
                    Authorization: 'Bearer ' + keycloak.token,
                    Accept: '*/*',
                    'Content-Type': 'application/json'
                }
            }
        ).then((response) => response.data);
    }

    public getContactById(id: string): Promise<ContactDTO> {
        return axios.get("/api/contact/" + id, {
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

    public deleteContact(id: string): Promise<void> {
        return axios.delete("/api/contact/" + id, {
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "DELETE",
            }
        }).then((response) => response.data)
    }
}
